module.exports = __webpack_public_path__ + "static/media/open_link.34026834.svg";